import * as helpers from '../../helpers';
import { IndesignTextFieldsConfig } from './getData';
import { modifyElementContent } from '../../editableTextFields/saveData';
import constants from '../constants';
import { emptyTextFieldClassName } from '../../../constants';

// Set min-height property equal line-height to all empty paragraphs for proper display in Reader
const modifyEmptyParagraphs = (fieldElement: HTMLElement): void => {
	const emptyParagraphs = [...fieldElement.querySelectorAll('p')].filter(p => !p.innerText);

	emptyParagraphs.forEach((p) => {
		if (p.style.minHeight === 'auto') {
			p.style.minHeight = p.style.lineHeight;
		}
	});
};

export default (htmlDocument: Document, fields: IndesignTextFieldsConfig[]): void => {
	fields.forEach(({ id, content, isEditedFromBackoffice, isEmpty, verticalAlignClassName }) => {
		if (!isEditedFromBackoffice) {
			return;
		}

		const fieldElement = htmlDocument.querySelector(`#${id}`) as HTMLElement;

		if (fieldElement) {
			helpers.setElementIsEdited(fieldElement);
			helpers.setVerticalAlignClassName(fieldElement, verticalAlignClassName);
			fieldElement.classList.toggle(emptyTextFieldClassName, !!isEmpty);
			const innerDiv = fieldElement.querySelector('div') as HTMLElement;
			const scale = helpers.getScaleFromStyle(innerDiv.style);
			const { style: { transform, width, height } } = innerDiv;

			innerDiv.style.transform = (transform as string).replace(/scale\((.+?)\)/, '');
			innerDiv.style.width = `${helpers.getNumberFromString(width as string) * scale}px`;
			innerDiv.style.height = `${helpers.getNumberFromString(height as string) * scale}px`;
			innerDiv.innerHTML = content;
			modifyElementContent(fieldElement, modifyEmptyParagraphs);

			const parentElement = fieldElement.closest(`[id*=${constants.parentContainerId}]:not([class*=${constants.textFieldClassName}])`);

			if (parentElement) {
				const linkElement = parentElement.querySelector('a');

				if (linkElement && helpers.isEditableButtonLink(linkElement)) {
					parentElement.classList.add(constants.editableButtonLinkClassName);
				}
			}
		}
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/editableTextFields/saveData.ts